import { types } from './actions';

export interface AppBarState {
  back: boolean;
  title: string;
}

export const appBarInitialState = {
  back: false,
  title: 'Bad Developer. Set a Title.',
};

export default function appBarReducer(state = appBarInitialState, action: any) {
  switch (action.type) {
    case types.SHOW_BACK:
      return { ...state, back: action.payload };
    case types.SET_TITLE:
      return { ...state, title: action.payload };
    default:
      return state;
  }
}
